import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73dd2158"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "author dark" }
const _hoisted_2 = { class: "page-default page-media" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "page-content" }
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "desc" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))
const _hoisted_10 = {
  class: "page-default page-media",
  style: {"padding-top":"0"}
}
const _hoisted_11 = { class: "page-title" }

import movieAuthor, { State } from '@/store/channels/author';
import Avatar from '@/views/components/Avatar.vue';
import Pagination from '@/views/components/Pagination.vue';
import * as links from '@/views/links';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import MovieItem from '../MovieItem.vue'
import i18, { State as I18State } from '@/store/i18';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore();
const data = computed<State>(() => store.state[movieAuthor.name])
const list = computed(() => data.value.albums.slice(0, data.value.pageSize))
const container = ref<HTMLDivElement>()

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]])

onMounted(() => {
    window.onresize = onResize;
    onResize();
})

onBeforeUnmount(() => {
    window.onresize = null
})

function onResize() {
    let rect = container.value?.getBoundingClientRect() as DOMRect;
    if (rect.width > 0) {
        let size = Math.floor((rect.width + 20) / 170);
        data.value.pageSize = Math.ceil(20 / size) * size;
    } else {
        data.value.pageSize = 24
    }
}

function onPageChange(page: number) {
    if (data.value.speaker) {
        router.push(`/channels/authors/${data.value.speaker.id}/pages/${page}.html`)
    }
}

function onMovie(item: any) {
    router.push(`/channels/movies/${item.movid}.html`)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(lang).movieText.author_intro), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(Avatar, {
              url: _unref(data).speaker?.thumb
            }, null, 8, ["url"]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(data).speaker?.name), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              innerHTML: _unref(data).speaker?.content
            }, null, 8, _hoisted_8)
          ]),
          _hoisted_9
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("b", null, _toDisplayString(_unref(lang).movieText.author_videos), 1)
      ]),
      _createElementVNode("div", {
        class: "albums",
        ref_key: "container",
        ref: container
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item) => {
          return (_openBlock(), _createBlock(MovieItem, {
            album: item,
            onClick: ($event: any) => (onMovie(item))
          }, null, 8, ["album", "onClick"]))
        }), 256))
      ], 512),
      _createVNode(Pagination, {
        total: _unref(data).total,
        page: _unref(data).page,
        size: _unref(data).pageSize,
        onChange: onPageChange
      }, null, 8, ["total", "page", "size"])
    ])
  ]))
}
}

})